var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('app-loader',{attrs:{"loading":_vm.getLoaderStatus,"color":_vm.options.color,"size":_vm.options.size}}),_vm._v(" "),(!_vm.getLoaderStatus)?_c('div',{staticClass:"columns"},[_c('right-side',{attrs:{"lot":_vm.getLot}}),_vm._v(" "),_c('left-side',{attrs:{"lot":_vm.getLot}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb45c4d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StockCars/StockCar.vue
// module id = null
// module chunks = 